export const gitCommit = 'd718a157'
